<template>
  <div id="errorLogMain">
    <el-row>
      <el-col :span="24"
              class="titleLine">
        <el-breadcrumb separator-class="el-icon-arrow-right"
                       class="titleLine1">
          <el-breadcrumb-item>设备</el-breadcrumb-item>
          <el-breadcrumb-item>设备管理</el-breadcrumb-item>
          <el-breadcrumb-item>异常日志</el-breadcrumb-item>
        </el-breadcrumb>
      </el-col>
    </el-row>
    <el-form :inline="true"
             label-width="80px">
      <el-row>
        <el-col :span="24">
          <el-form-item label="客户::">
            <el-select v-model="pageSearch.fCustID"
                       filterable
                       placeholder="请选择客户"
                       style="width:200px;"
                       clearable>
              <el-option v-for="item in cust_list"
                         :key="item.fCustID"
                         :label="item.unionName"
                         :value="item.fCustID">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="内网IP::">
            <el-input placeholder="请输入IP"
                      style="width:200px;"
                      v-model="pageSearch.fPriIP">
            </el-input>
          </el-form-item>
          <el-form-item label="内容::">
            <el-input placeholder="请输入内容"
                      style="width:200px;"
                      v-model="pageSearch.fRemark">
            </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="年份::">
            <el-select v-model="pageSearch.year"
                       style="width:200px;"
                       placeholder="请选择年份">
              <el-option v-for="item in year_list"
                         :key="item.value"
                         :label="item.value"
                         :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="开始时间::">
            <el-date-picker v-model="pageSearch.startTime"
                            type="datetime"
                            style="width:200px;"
                            :picker-options="pickOption"
                            placeholder="请选择开始时间">
            </el-date-picker>
          </el-form-item>
          <el-form-item label="结束时间::">
            <el-date-picker v-model="pageSearch.endTime"
                            :picker-options="pickOption"
                            type="datetime"
                            style="width:200px;"
                            placeholder="请选择结束时间">
            </el-date-picker>
          </el-form-item>

          <el-form-item>
            <el-button type="primary"
                       size="small"
                       icon="el-icon-search"
                       @click="init">查询</el-button>
            <!-- <el-button type="success"
                       size="small"
                       icon="el-icon-search"
                       @click="init(1,0)">正常</el-button>
            <el-button type="danger"
                       size="small"
                       icon="el-icon-search"
                       @click="init(1,1)">异常</el-button> -->
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <el-row>
      <el-col :span="24">
        <el-table :data="pageData"
                  :height="tableHeight"
                  highlight-current-row
                  v-loading="loading"
                  border
                  stripe
                  style="width: 100%">
          <el-table-column width="50"
                           type="index"
                           :index="indexMethod"
                           align="right"
                           label="序号">
          </el-table-column>
          <el-table-column prop="fCustNo"
                           label="客户编号"
                           width="80">
          </el-table-column>
          <el-table-column prop="fCustName"
                           label="客户名称">
          </el-table-column>
          <el-table-column prop="fCltTimeName"
                           label="客户端时间"
                           width="190">
          </el-table-column>
          <el-table-column prop="fMacType"
                           width="150"
                           label="机器类型">
          </el-table-column>
          <el-table-column prop="fMacName"
                           width="120"
                           label="机器名称">
          </el-table-column>
          <el-table-column prop="fPriIP"
                           width="125"
                           label="内网IP">
          </el-table-column>
          <el-table-column prop="fSysName"
                           width="100"
                           label="系统名称">
          </el-table-column>
          <el-table-column prop="fFunName"
                           width="150"
                           label="功能模块">
          </el-table-column>
          <el-table-column prop="fLevel"
                           width="100"
                           label="级别">
          </el-table-column>
          <el-table-column label="备注"
                           prop="fRemark">
          </el-table-column>
          <el-table-column label="操作"
                           fixed="right"
                           align="center"
                           width="100">
            <template slot-scope="scope">
              <el-button size="mini"
                         type="success"
                         @click="handleInfo(scope.$index, scope.row)">查看</el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-col>
    </el-row>
    <el-row class="pagination">
      <el-col :span="24">
        <div class="block">
          <span class="demonstration"></span>
          <el-pagination @current-change="handleCurrentChange"
                         @size-change="handleSizeChange"
                         :current-page="pageSearch.pageIndex"
                         :page-size="pageSearch.pageSize"
                         :page-sizes="[10, 20, 50, 100]"
                         background
                         layout="total,sizes, prev, pager, next, jumper"
                         :total="pageCount"
                         v-if="pageCount>0">
          </el-pagination>
        </div>
      </el-col>
    </el-row>
    <el-dialog :title="dialogTitle"
               width="50%"
               top="7vh"
               :visible.sync="dialogVisible"
               v-dialogDrag>
      <el-form ref="form"
               :model="form"
               label-width="110px">
        <el-row>
          <el-col :span="12">
            <el-form-item label="客户编号::">
              <el-input v-model="form.fCustNo"
                        :disabled="true"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="客户名称::">
              <el-input v-model="form.fCustName"
                        :disabled="true"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="记录编号::">
              <el-input v-model="form.fBigRowID"
                        :disabled="true"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="最后操作时间::">
              <el-input v-model="form.fOpLastTimeName"
                        :disabled="true"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="服务器时间::">
              <el-input v-model="form.fSvrTimeName"
                        :disabled="true"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="客户端时间::">
              <el-input v-model="form.fCltTimeName"
                        :disabled="true"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="CPU编号::">
              <el-input v-model="form.fCPUID"
                        :disabled="true"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="Mac地址::">
              <el-input v-model="form.fMacAddr"
                        :disabled="true"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="机器类型::">
              <el-input v-model="form.fMacType"
                        :disabled="true"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="机器名称::">
              <el-input v-model="form.fMacName"
                        :disabled="true"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="公网IP::">
              <el-input v-model="form.fPubIP"
                        :disabled="true"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="内网IP::">
              <el-input v-model="form.fPriIP"
                        :disabled="true"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="系统名称::">
              <el-input v-model="form.fSysName"
                        :disabled="true"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="进程名称::">
              <el-input v-model="form.fProcName"
                        :disabled="true"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="模块名称::">
              <el-input v-model="form.fModName"
                        :disabled="true"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="功能名称::">
              <el-input v-model="form.fFunName"
                        :disabled="true"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="日志级别::">
              <el-input v-model="form.fLevel"
                        :disabled="true"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="是否错误::">
              <el-input :value="(form.fIsError==='1'?'是':'否')"
                        :disabled="true"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row class="fRemark_row">
          <el-col :span="24">
            <el-form-item label="备注::"
                          prop="fRemark">
              <el-input type="textarea"
                        v-model="form.fRemark"
                        :disabled="true"
                        id="fRemark"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer"
           class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { device } from '../../api/device'
import * as park from '../../api/park'
import * as user from '../../api/user'
export default {
  data () {
    return {
      is_export: false,
      tableHeight: 0,
      dialogTitle: '',
      dialogVisible: false,
      form: {},
      pickOption: {
        disabledDate: (value) => {
          if (this.pageSearch.year === value.getFullYear()) {
            return false
          }
          return true
        }
      },
      loading: false,
      pageData: [],
      cust_list: [],
      year_list: [{ value: new Date().getFullYear() }, { value: new Date().getFullYear() - 1 }],
      pageCount: 0,
      pageSearch: {
        pageIndex: 1,
        pageSize: 20,
        year: new Date().getFullYear(),
        startTime: '',
        endTime: '',
        fCustID: '',
        fPriIP: '',
        fRemark: ''
      }
    }
  },
  methods: {
    init (index) {
      if (index && index >= 1) {
        this.pageSearch.pageIndex = index
      } else {
        this.pageSearch.pageIndex = 1
      }
      if (this.pageSearch.startTime instanceof Date) {
        this.pageSearch.startTime = this.$dateFormat(this.pageSearch.startTime, 'yyyy-MM-dd hh:mm:ss')
      }
      if (this.pageSearch.endTime instanceof Date) {
        this.pageSearch.endTime = this.$dateFormat(this.pageSearch.endTime, 'yyyy-MM-dd hh:mm:ss')
      }
      this.loading = true
      device.errorLogPageList(this.pageSearch).then(res => {
        this.loading = false
        if (res && res.data) {
          var data = res.data
          if (data.IsOk) {
            this.pageData = data.Data.data
            this.pageCount = data.Data.count
          } else {
            this.$message.error('提示：' + data.Msg)
          }
        }
      })
    },
    tableRowClassName ({ row, rowIndex }) {
      if (row.fIsError === '1') {
        return 'warning-row'
      }
      return ''
    },
    indexMethod (index) {
      return this.pageSearch.pageSize * (this.pageSearch.pageIndex - 1) + index + 1
    },
    handleSizeChange (val) {
      this.pageSearch.pageSize = val
      this.init(this.pageSearch.pageIndex)
    },
    handleCurrentChange (val) {
      this.init(val)
    },
    loadCust () {
      park.getCustByGroup().then(res => {
        if (res && res.data) {
          var data = res.data
          if (data.IsOk) {
            this.cust_list = data.Data || []
          } else {
            this.$message.error('提示：加载客户列表失败')
          }
        }
      })
    },
    handleInfo (index, row) {
      this.form = row
      this.dialogTitle = '查看日志'
      this.dialogVisible = true
    },
    setTableHeight (obj) {
      let clientHeight = obj.getRJPageSize.getRJPageSize()[3] - 255
      obj.tableHeight = clientHeight
    }
  },
  created () {
    var today = new Date()
    this.pageSearch.year = today.getFullYear()
    this.pageSearch.startTime = new Date(today.getFullYear(), today.getMonth(), today.getDate(), 0, 0, 0)
    this.pageSearch.endTime = new Date(today.getFullYear(), today.getMonth(), today.getDate(), 23, 59, 59)
    user.getCurrentUserPers({ perTypeId: 71000 }).then(res => {
      if (res && res.data) {
        var data = res.data
        if (data.IsOk) {
          if (data.Data) {
            this.is_export = data.Data.data.is_export
          }
        } else {
          this.$message.error('提示：加载当前用户权限信息失败')
        }
      }
    })
  },
  mounted () {
    window.onresize = () => {
      this.setTableHeight(this)
    }
    this.loadCust()
  },
  updated () {
    this.setTableHeight(this)
  }
}
</script>
<style>
/* dialog弹出框样式 */
#errorLogMain .el-dialog__headerbtn {
  top: 10px;
  font-size: 20px;
}
#errorLogMain .el-dialog__title {
  color: white;
}
#errorLogMain .el-dialog__header {
  background-color: #337ab7;
  padding: 10px;
}
#errorLogMain .el-dialog__body {
  padding: 10px 10px 10px 10px;
}
#errorLogMain .el-input.is-disabled .el-input__inner,
#errorLogMain .is-disabled .el-textarea__inner {
  color: #606266;
}
#errorLogMain #fRemark {
  height: 180px;
}
#errorLogMain .fRemark_row .el-form-item__content {
  height: 180px;
}
#errorLogMain .warning-row {
  color: #f56c6c;
}
#errorLogMain .tip span {
  padding-right: 10px;
  font-weight: bold;
  color: #ccc;
}
#errorLogMain .tip span.msg_value {
  padding-right: 0px;
  color: darkseagreen;
}
</style>
<style scoped>
.el-form-item {
  margin-bottom: 10px;
}
.pagination {
  text-align: right;
  padding-top: 5px;
}
.search {
  width: 300px;
}
.tip {
  text-align: center;
  position: absolute;
  top: 12px;
  right: 40px;
}
.log_search {
  margin-bottom: 10px;
}
</style>



// WEBPACK FOOTER //
// src/view/device/errorLogMain.vue